import { positionOpts, layoutOpts } from './common'

// 图例信息
export const legendDefault = {
  legendVisible: true,
  legendPosition: 'top-left',
  legendLayout: 'horizontal',
  legendShape: 'hyphen',
  legendTextColor: '#fff'
}

export const legendShapeOpts = [
  {
    value: 'circle',
    label: 'Circle'
  },
  {
    value: 'square',
    label: 'Square'
  },
  {
    value: 'line',
    label: 'Vertical line'
  },
  {
    value: 'diamond',
    label: 'Diamond'
  },
  {
    value: 'triangle',
    label: 'Triangle'
  },
  {
    value: 'triangle-down',
    label: 'TriangleDown'
  },
  {
    value: 'hexagon',
    label: 'Hexagon'
  },
  {
    value: 'bowtie',
    label: 'Bowtie'
  },
  {
    value: 'cross',
    label: 'Cross'
  },
  {
    value: 'plus',
    label: 'Plus'
  },
  {
    value: 'hyphen',
    label: 'Hyphen'
  }
]

export const legendConfig = [
  {
    info: {
      title: '图例（Legend）',
      icon: 'icon-setting'
    },
    fields: [
      { title: '显示图例', name: 'legendVisible', description: '设置是否显示', type: 'switch' },
      {
        title: '图例位置',
        name: 'legendPosition',
        description: '',
        type: 'select',
        options: [...positionOpts()],
        visible: ({ legendVisible }) => legendVisible === true
      },
      {
        title: '图例布局',
        name: 'legendLayout',
        description: '',
        type: 'select',
        options: layoutOpts,
        visible: ({ legendVisible }) => legendVisible === true
      },
      {
        title: '图例形状',
        name: 'legendShape',
        type: 'select',
        options: legendShapeOpts,
        visible: ({ legendVisible }) => legendVisible === true
      },
      {
        title: '文本颜色',
        name: 'legendTextColor',
        type: 'color',
        visible: ({ legendVisible }) => legendVisible === true
      }
    ]
  }
]

export function calcLegendData(options) {
  let calcData = {}
  if (options.legendVisible) {
    calcData = {
      layout: options.legendLayout,
      position: options.legendPosition,
      itemName: {
        style: {
          fill: options.legendTextColor
        }
      },
      marker: {
        symbol: options.legendShape
      }
    }
  } else {
    calcData = false
  }
  return calcData
}
